import { useEffect, useState } from "react";

type Role = "admin" | "entity" | "cashier" | null;

export function useRole(): { role: Role; loading: boolean } {
  const [role, setRole] = useState<Role>(() => {
    const storedRole = localStorage.getItem("userRole");
    return storedRole ? (storedRole.toLowerCase() as Role) : null;
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const syncRole = () => {
      const storedRole = localStorage.getItem("userRole");
      setRole(storedRole ? (storedRole.toLowerCase() as Role) : null);
    };

    syncRole();
    setLoading(false);

    window.addEventListener("storage", syncRole);
    window.addEventListener("gameoo-auth-changed", syncRole);

    return () => {
      window.removeEventListener("storage", syncRole);
      window.removeEventListener("gameoo-auth-changed", syncRole);
    };
  }, []);

  return { role, loading };
}
